<template>
  <div class="index">
    <el-container class="containerNTET">
      <el-header class="header" style="height:70px" v-if="url!=='publics'">
       <Header />
      </el-header>
      <el-container>
        <el-aside  v-if="url!=='publics'" :style="{'width': collapse ==false ? 150+'px' : 50+'px'}" class="aside">
          <leftContent/>
         
        </el-aside>
        <el-main class="main">
          <el-card style="height:100%; overflow: auto;">
             <router-view />
           </el-card>
        </el-main>
      
      </el-container>
    </el-container>
   <div style="display: none;"> {{paht}}</div>
  </div>
</template>
<script>
import Header from '@/components/common/header'
import leftContent from '@/components/common/leftContent'
import bus from '@/components/common/bus'

export default {
  components:{
    Header,
    leftContent,
  },
  data(){
    return{
       collapse:false,
       fly:true,
       url:''
    }
  },
  computed:{
    paht(){
      return this.$route.path != '/list'? this.collapse = false : this.collapse = true
    },
  },
  created(){
    let aa=window.location.href.split('/')
    let bb=aa[3].split('?')
    this.url=bb[0]
    bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });
  },
};
</script>
<style lang="scss">
.header,
.el-header {
  padding: 0;
}
.index {
  width: 100%;
  height: 100%;
}
.containerNTET {
  width: 100%;
  height: 100%;
}
.header {
   box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  color: #333;
  text-align: center;
}

.aside {
  // background-color: #d3dce6;
  // height: 100%;
}
.main{
  // height: 100%;
  
  // overflow: auto;
}

</style>